import { action$, extractPayload, ofType, withNamespace } from '@ardoq/rxbeach';
import { setIsViewExporting } from './actions';
import { startWith } from 'rxjs/operators';
import { ViewIds } from '@ardoq/api-types';

const initialState = { isExporting: false };

const getIsViewExportingStream = (viewId: ViewIds) =>
  action$.pipe(
    withNamespace(viewId),
    ofType(setIsViewExporting),
    extractPayload(),
    startWith(initialState)
  );

export { getIsViewExportingStream };
